<template>

  <svg
    t="1631089161214"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5655"
    width="64"
    height="64"
  ><path d="M504.70452679 37.87343986H59.10203165v445.60249515h445.60249514V37.87343986z m-50.80983552 394.79265963H109.9118683V88.68327651h343.98165903v343.98282298zM3.74329458 986.12656014h528.03575011L267.76117021 528.83337785 3.74329458 986.12656014z m88.00557056-50.8110006l176.01230507-304.86250951 176.01230392 304.86250951h-352.02460899zM649.82924857 475.55174286l141.48979143-74.38448185 141.48746354 74.38448185-27.02328832-157.54658475 114.47232512-111.5790518-158.19160463-22.98900594-70.74489571-143.34567765-70.74489571 143.34567765-158.19393252 22.98900594 114.46999609 111.5790518-27.02095929 157.54658475z m21.74320981-233.6484022l82.74295695-12.02251093 37.00362467-74.9794361 37.00362581 74.9794361 82.74062792 12.02251093-59.87038095 58.35796139 14.13221376 82.41346104-74.00492145-38.90608355-74.00725163 38.90608355 14.13454279-82.41346104-59.87503787-58.35796139zM796.40002333 554.23829561c-114.51656875 0-207.68229376 93.16572615-207.68229376 207.6822949s93.16572615 207.68229376 207.68229376 207.68229376c114.51423971 0 207.67996587-93.16572615 207.67996586-207.68229376s-93.16572615-207.68229376-207.67996586-207.6822949z m0 364.55475314c-86.49897187 0-156.87245824-70.36999339-156.87245711-156.87245824s70.37232128-156.87245824 156.87245711-156.87245824 156.86896526 70.36999339 156.86896526 156.87245824-70.36999339 156.87245824-156.86896526 156.87245824z" p-id="5656" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconMaterial',
} as DefineComponent
</script>